import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './RatingPopup.scss';

const RatingPopup = ({ show, onClose, onSubmit, userName = 'il servizio' }) => {
  const [selectedRating, setSelectedRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);

  const handleStarClick = (rating) => {
    setSelectedRating(rating);
  };

  const handleStarHover = (rating) => {
    setHoveredRating(rating);
  };

  const handleSubmit = () => {
    if (selectedRating > 0) {
      onSubmit(selectedRating);
      setSelectedRating(0);
      setHoveredRating(0);
    }
  };

  const handleSkip = () => {
    onClose();
    setSelectedRating(0);
    setHoveredRating(0);
  };

  const displayRating = hoveredRating || selectedRating;

  return (
    <Modal
      show={show}
      onHide={handleSkip}
      centered
      backdrop="static"
      keyboard={false}
      className="rating-popup-modal"
    >
      <Modal.Header>
        <Modal.Title>Valutazione del servizio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="rating-content">
          <p className="rating-question">
            La tua opinione è importante! Aiutaci a migliorare valutando la tua esperienza con il
            servizio di interpretariato LIS
          </p>
          <div className="stars-container">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                className={`star-button ${displayRating >= star ? 'active' : ''}`}
                onClick={() => handleStarClick(star)}
                onMouseEnter={() => handleStarHover(star)}
                onMouseLeave={() => setHoveredRating(0)}
                type="button"
              >
                <i className={`fas fa-star ${displayRating >= star ? 'filled' : ''}`}></i>
              </button>
            ))}
          </div>
          {selectedRating > 0 && (
            <p className="rating-text">
              Hai selezionato: {selectedRating} {selectedRating === 1 ? 'stella' : 'stelle'}
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleSkip}>
          Salta
        </button>
        <button className="btn btn-primary" onClick={handleSubmit} disabled={selectedRating === 0}>
          Invia Valutazione
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RatingPopup;
